// src/components/WalletConnect.jsx
import React from 'react';
import Button from './CoverPage/Button';

import './WalletConnect.css';

const WalletConnect = ({ isLoading, onConnect }) => {
  return (
    <section className="wallet-connect-section h-[100svh] w-[100svw] overflow-hidden relative px-5 flex items-center justify-center max-sm:px-5">
      <div className="relative mx-auto text-center max-w-[1200px] z-[1]">
        <h2 className="mb-6 text-5xl font-bold text-white max-sm:text-3xl">Welcome to YildX Fund</h2>
        <p className="mx-auto mt-0 mb-10 text-xl leading-relaxed max-w-[800px] text-white text-opacity-90 max-sm:text-lg">
          Connect your wallet, deposit ETH, mint tokens and manage your positions.
        </p>
        <div className="flex gap-4 justify-center max-sm:flex-col max-sm:items-center">
          <Button 
            variant="primary" 
            onClick={onConnect} 
            className={isLoading ? 'opacity-50 cursor-not-allowed' : ''}
            disabled={isLoading}
          >
            {isLoading ? 'Connecting...' : 'Connect Wallet'}
          </Button>
        </div>
      </div>
      
      {/* Background elements - keeping these for visual appeal */}
      <div className="absolute top-0 left-0 w-32 h-32 bg-white opacity-5 rounded-full -translate-x-1/2 -translate-y-1/2 blur-lg"></div>
      <div className="absolute bottom-0 right-0 w-64 h-64 bg-indigo-400 opacity-10 rounded-full translate-x-1/3 translate-y-1/3 blur-xl"></div>
      <div className="absolute bottom-32 left-20 w-20 h-20 bg-blue-300 opacity-10 rounded-full blur-md"></div>
    </section>
  );
};

export default WalletConnect;